import React, { useContext, useEffect, useState } from 'react';
import { Field, reduxForm } from 'redux-form';
import EyeIcon from 'mdi-react/EyeIcon';
import KeyVariantIcon from 'mdi-react/KeyVariantIcon';
import AccountOutlineIcon from 'mdi-react/AccountOutlineIcon';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

import { URL } from '../../../config/api';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';
import { enableSpinner, disableSpinner, setAuthState } from '../../../redux/actions/appActions';
import { useHistory } from 'react-router-dom';
import AuthContext from '../../App/authContext';


import { Form, Button, Row, Col, Upload, message, Menu, Dropdown } from 'antd';
import { LoadingOutlined, PlusOutlined, DownOutlined, UserOutlined } from '@ant-design/icons';

const AddStickerForm = () => {
  const dispatch = useDispatch();
  const [categories, setCategories] = useState([]);
  const [categoryName, setCategoryName] = useState('Select Category');
  const [categoryId, setCategoryId] = useState(0);
  const [name, setName] = useState('');
  const [tags, setTags] = useState('');
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState('');
  const [realImageUrl, setRealImageUrl] = useState('');

  const [svgUrl, setSvgUrl] = useState('');
  const [realSvgUrl, setRealSvgUrl] = useState('');

  const [form] = Form.useForm();
  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  useEffect(() => {
    loadResults();
  }, []);

  const loadResults = async () => {
    const bodyFormData = new FormData();
    try {
      const res = await axios.post(`${URL}/sticker/get_category.php`, bodyFormData);
      if(res.data.Success) {
        const data = res.data.Data;
        setCategories(data);
      }else {
        alert(res.data.Message);
      }
    }catch(error) {
      console.log(error);

    }
  }

  function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error('Image must smaller than 2MB!');
    }
    return isJpgOrPng && isLt2M;
}

  function beforeUpload1(file) {
      const isSvg = file.type === 'image/svg+xml';
      if (!isSvg) {
          message.error('You can only upload svg file!');
      }

      return isSvg;
  }

  function handleChange(info) {
      console.log("HANDLE CHANGE", info);
      if (info.file.status === 'uploading') {
          setLoading(true);
          return;
      }
      if (info.file.status === 'done') {
          getBase64(info.file.originFileObj, localImageUrl => {
                  setImageUrl(localImageUrl);
                  setLoading(false);
              }
          );
          
          setRealImageUrl(info.file.response.ImageUrl);
      }
  };

  function handleChange1(info) {
      console.log("HANDLE CHANGE", info);
      if (info.file.status === 'uploading') {
          setLoading(true);
          return;
      }
      if (info.file.status === 'done') {
          getBase64(info.file.originFileObj, localImageUrl => {
                  setSvgUrl(localImageUrl);
                  setLoading(false);
              }
          );
          
          setRealSvgUrl(info.file.response.SvgUrl);
      }
  };

  function getBase64(img, callback) {
      const reader = new FileReader();
      reader.addEventListener('load', () => callback(reader.result));
      reader.readAsDataURL(img);
  }

  function handleMenuClick(e) {
    const index = e.key;
    let category = categories[index];
    setCategoryName(category.Name);
    setCategoryId(category.Id);
  }

  const menu = (
    <Menu onClick={handleMenuClick}>
            {categories.map((item, index) => (
                <Menu.Item key={index}>
                    {item.Name}
                </Menu.Item>
            ))}
    </Menu>
  );

  const onFinish = async () => {
    /*handleSubmit({
        categoryId: categoryId,
        name: name,
        imageUrl: realImageUrl,
        svgUrl: realSvgUrl,
        tags: tags
    })*/
    const bodyFormData = new FormData();
    bodyFormData.append('CategoryId', categoryId);
    bodyFormData.append('ImageName', name);
    bodyFormData.append('Tag', tags);
    bodyFormData.append('SvgUrl', svgUrl);

    try {
      if(imageUrl == "") {
        message.error("Image is required");
        return;
      }
      
      if(categoryId == 0) {
        message.error("Category is required");
        return;
      }

      dispatch(enableSpinner('Loading..'));
      const res = await axios.post(`${URL}/sticker/add_sticker_worker.php`, bodyFormData);
      dispatch(disableSpinner());

      if(res.data.Success) {
        message.success(res.data.Message);
        loadResults();

        setImageUrl("");
        setSvgUrl("");
        setName("");
        setTags("");
        form.setFieldsValue({
          name: "",
          tags: ""
        })
      } else {
        message.error(res.data.Message);
      }
    }catch(error) {
      console.log(error);
      dispatch(disableSpinner());
    }
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <div className="form form--horizontal">
          <Row gutter={16} style={{width: '100%'}}>
              <Col span={24}>
                  <Form.Item>
                      <Dropdown placement="bottomLeft" overlay={menu}>
                          <Button>{categoryName}</Button>
                      </Dropdown>
                  </Form.Item>

                  <Form.Item name="name" label="Name"
                      rules={[
                          {
                              required: true,
                              message: `Name is required!`,
                          },
                      ]}>
                      <input
                          name="name"
                          type="name"
                          value={name}
                          placeholder="Name"
                          onChange={(e) => setName(e.target.value)}
                      />
                  </Form.Item>

                  <Form.Item name="image" label="Image">
                    <Upload
                          name="image"
                          listType="picture-card"
                          className="avatar-uploader"
                          showUploadList={false}
                          action={`${URL}/sticker/upload_image.php`}
                          beforeUpload={beforeUpload}
                          onChange={handleChange}
                      >
                          {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                      </Upload>
                  </Form.Item>

                  <Form.Item name="svg" label="SVG">
                    <Upload
                          name="svg"
                          listType="picture-card"
                          className="avatar-uploader"
                          showUploadList={false}
                          action={`${URL}/sticker/upload_svg.php`}
                          beforeUpload={beforeUpload1}
                          onChange={handleChange1}
                      >
                          {svgUrl ? <img src={svgUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                      </Upload>
                  </Form.Item>

                  <Form.Item name="tags" label="Tags"
                        rules={[
                          {
                              required: true,
                              message: `Tags is required!`,
                          },
                      ]}>
                      <input
                          name="tags"
                          type="tags"
                          value={tags}
                          placeholder="Tags"
                          onChange={(e) => setTags(e.target.value)}
                      />
                  </Form.Item>
              </Col>
          </Row>
      </div>
      <Row style={{justifyContent: 'center'}}>
          <Button type="primary" htmlType="submit">Add</Button>
      </Row>
  </Form>
  );
};

export default reduxForm({
  form: 'add_sticker_form',
})(AddStickerForm);
